import { ImageList, ImageListItem, ImageListItemBar, Typography } from "@mui/material"
import { TestData } from "graphql/types"
import { getImageURL } from "utils/getFileURL"

type TaskNoteCardProps = {
  testData: TestData
}

export const TaskNoteCard = (props: TaskNoteCardProps) => {
  const { testData } = props
  return (
    <>
      <Typography variant="body2">{testData.description}</Typography>
      <ImageList sx={{ width: "100%" }} cols={4}>
        {testData.image?.map((item) => (
          <ImageListItem key={item.id}>
            <img src={getImageURL(item.id)} alt={item.name} />
            <ImageListItemBar subtitle={item.name} position="below" />
          </ImageListItem>
        ))}
      </ImageList>
    </>
  )
}
